module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.10938/js/img/MarketingHub_Icon.svg"